import { UtilsService } from 'src/app/services/utils.service';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Question } from 'src/app/models/question.model';
import { Test } from 'src/app/models/test.model';
import { fromQuestion } from 'src/app/reducers/question.reducer';
import { fromTest } from 'src/app/reducers/test.reducer';
import { AppConfig } from 'src/app/helpers/app.config';
import { TestService } from 'src/app/services/test.service';

@Component({
  selector: 'ct-finalized',
  templateUrl: './finalized.component.html',
  styleUrls: ['./finalized.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FinalizedComponent implements OnInit {

  @Input() colors: any;

  public finalizeAnimation: object;
  public finalizeAnimationMobile: object;

  public test$: Observable<Test>;
  public question$: Observable<Question>;

  public currentTest: Test;
  public currentQuestion: Question;
  public randomInt;
  public ADNTestModelIds = this.utilsService.ADNTestModelIds;
  // corregido para ESFBITE-1342 por pentest para evitar XSS
  public get sanitizedCandidateName(): string {
    const name = this.currentTest?.candidate?.name || '';
    return name.replace(/[<>"'&]/g, '');
  }

  constructor(
    private store: Store,
    private router: Router,
    private utilsService: UtilsService,
    private testService: TestService
  ) {
    this.finalizeAnimation = { path: 'assets/animations/confeti.json' };
    this.finalizeAnimationMobile = { path: 'assets/animations/confeti-responsive.json' };
  }

  ngOnInit(): void {

    this.randomInt = Math.floor(Math.random() * 2) + 1;

    this.test$ = this.store.pipe(select(fromTest.selectTestState));
    this.question$ = this.store.pipe(select(fromQuestion.selectQuestionState));

    let count = 0;
    this.test$.subscribe(test => {
      this.currentTest = test;
      // La subscripcion se ejecuta 2 veces (es correcto) pero solo queremos que se ejecute una vez el envio de informe y no queremos de error aunque falle el envío(lo intentará la lambda despues)
      if (count == 0) {
        try {
          this.testService.sendReport(test.id).subscribe(res => { });
        } catch (error) { console.log(error); }
      }
      count++;
    });

    this.question$.subscribe(question => {
      this.currentQuestion = question;
    });
  }

  public returnHome() {
    if (this.currentTest.invitation.origin === 'myrandstad') {
      location.href = AppConfig.settings.MYRANDSTAD + '/myrandstad/tests?navigation=finishedTests';
    } else {
      this.router.navigate(['candidate/home/' + this.currentTest.invitation.token], { queryParams: { testToken: this.currentTest.token } });
    }
  }

}
